import { Accordion, Header } from '@mairistem/composants';
import React from 'react';

const ErrorToastContent = ({ description = null }) => {
  const [active, setActive] = React.useState(false);

  return (
    <Header>
      Une erreur est survenue
      <Header.Subheader>
        <Accordion>
          <Accordion.Title data-testid="toast-description-click" onClick={() => setActive(true)}>
            {description || "L'enregistrement a échoué"}
          </Accordion.Title>
          <Accordion.Content active={active}>
            <p>Si le problème persiste, veuillez contacter votre admnistrateur</p>
          </Accordion.Content>
        </Accordion>
      </Header.Subheader>
    </Header>
  );
};
export default ErrorToastContent;
